import React from 'react';
import {LIBRARY_TYPES} from '../../utils/dashboardChartOrder';
import {chartLibraryPreview, type PreviewTone} from '../../utils/chartLibraryPreview';
export default function ChartLibraryPreview({type, large = false, setting}: {
  type: string;
  large?: boolean;
  setting?: Record<string, unknown>;
}) {
  const palette: Record<PreviewTone, string> = {
    accent: 'var(--accent)', pink: '#F877B1', purple: '#A887E3', blue: '#79B4EE',
    teal: '#24CFB0', gold: '#F5B740', muted: 'var(--fg-3)', grid: 'var(--border-subtle,rgba(140,150,165,.22))',
  };
  const ws = setting?.workout_summery as Record<string, unknown> | undefined;
  const shapes = chartLibraryPreview(LIBRARY_TYPES[type]?.preview ?? 'bars', String(ws?.workout_summery_types ?? ''));
  return <svg className={large ? 'chart-library__preview large' : 'chart-library__preview'} viewBox="0 0 120 64" aria-hidden="true" focusable="false">
    <rect width="120" height="64" rx="8" fill="var(--surface-sunken,var(--surface-1))" />
    {shapes.map(({kind, fill, stroke, ...shape}, i) => {
      const paint = {...shape, fill: fill ? palette[fill] : 'none', stroke: stroke ? palette[stroke] : 'none'};
      return kind === 'rect' ? <rect key={i} {...paint} /> : kind === 'circle' ? <circle key={i} {...paint} /> : <path key={i} {...paint} strokeLinecap="round" strokeLinejoin="round" />;
    })}
  </svg>;
}
